import { render } from "./CorrectView.vue?vue&type=template&id=4672b95c&scoped=true&ts=true"
import script from "./CorrectView.vue?vue&type=script&lang=ts"
export * from "./CorrectView.vue?vue&type=script&lang=ts"

import "./CorrectView.vue?vue&type=style&index=0&id=4672b95c&lang=scss&scoped=true"

import exportComponent from "C:\\vue项目\\baiduobang\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4672b95c"]])

export default __exports__